export class AuthenticationClass {
    static IsValidLogin: boolean = false
}